import { Box, Typography, useTheme, Skeleton, Divider } from '@mui/material'
import { useNavigate } from 'react-router'
import { useContext } from 'react'
import { screenSearchResult, SearchResultTypes } from 'shared-solo/stores/SearchStore/SearchStore'
import RootStore from '~/stores/RootStore'
import { ProfileAvatar } from '../ProfileAvatar'
import StyledIcon from '../StyledIcon'
import icons from '~/assets/icons'

interface SearchResultsRowProps {
  item?: screenSearchResult
  loading?: boolean
  isLast?: boolean
}

export const SearchResultsRow = ({ item, loading, isLast }: SearchResultsRowProps) => {
  const theme = useTheme()
  const navigate = useNavigate()
  const store = useContext(RootStore)

  const { handleClick } = store.searchStore

  if (loading) {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(2),
            p: theme.spacing(3),
            width: '100%',
          }}
        >
          <Skeleton variant='circular' width={32} height={32} sx={{ bgcolor: 'secondary.dark' }} />
          <Skeleton variant='rectangular' width='40%' height={24} sx={{ bgcolor: 'secondary.dark' }} />
        </Box>
        {!isLast && <Divider variant='middle' />}
      </>
    )
  }

  if (!item?.address?.path) return null

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(2),
          p: theme.spacing(3),
          width: '100%',
          borderRadius: 1,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        }}
        onClick={() => handleClick(item, navigate)}
      >
        {item.type === SearchResultTypes.Screen && <StyledIcon name={item.icon as keyof typeof icons} />}
        {item.type === SearchResultTypes.Client && (
          <ProfileAvatar color={item.color} fullName={item.primaryTerm} />
        )}
        <Typography variant='subtitle2'>{item.primaryTerm}</Typography>
      </Box>
      {!isLast && <Divider variant='middle' />}
    </>
  )
}
